import OSS from "ali-oss"; // 导入阿里云OSS SDK
import requestApi from "@/js/http";

// 配置OSS参数
// const client = new OSS({
//     region: 'oss-cn-hangzhou', // 设置地区信息
//     accessKeyId: 'LTAI5t78P9rKM4zw6GhYC7HE', // 设置Access Key ID
//     accessKeySecret: 'IddFhTyW93bL8YkH1IBVtVJX5AyFRw', // 设置Access Key Secret
//     bucket: 'dndt-attachment' // 设置Bucket名称
// });

export const uploadFileToOss = async (file: File) => {
  try {
    requestApi.get("/Ai/getAiOSSUploadStsSchoolApply").then(async (res) => {
      const client = new OSS({
        region: "oss-cn-hangzhou", // 设置地区信息
        accessKeyId: res.data.data.accessKeyId, // 设置Access Key ID
        accessKeySecret: res.data.data.accessKeySecret, // 设置Access Key Secret
        bucket: "dndt-attachment", // 设置Bucket名称
        stsToken: res.data.data.securityToken,
        endpoint: "https://oss-cn-hangzhou.aliyuncs.com",
      });
      const result = await client.put("student/audio/" + file.name, file); // 调用client.put()方法上传文件
      return result; // 返回结果
    });
  } catch (error) {
    console.log("Error occurred while uploading the file to OSS: ", error);
    throw error;
  }
};
